import React from "react";
import {
    Button,
    checkAndSetError,
    CheckBoxField,
    clearInputFormErrorFields,
    convertInputFormToObject,
    DateTimePickerField,
    InputForm,
    inputFormIsValid,
    SelectField,
    TextArea,
    TextField,
    useInputForm,
} from "../../Components/Inputs";
import {GridCell, gridConstants} from "../../Components/Grid";
import {GRADE_LEVEL_LIST} from "./libraryConstants";
import {resourceModel} from "./libraryFactory";
import {isStartBeforeEnd} from "../../Utilities/Types/dateUtilities";

import type {ListItem} from "../../Utilities/Types/listUtilities";

interface LibraryItemViewProps {
    handleSaveResource: (data: Record<string, unknown>) => void;
    handleReturn: () => void;
    item: Record<string, any>;
    publishers: ListItem[];
}

export const LibraryItemView = ({
                                    handleSaveResource,
                                    handleReturn,
                                    item,
                                    publishers,
                                }: LibraryItemViewProps) => {
    const itemForm = useInputForm(resourceModel(item));
    const isActive = String(itemForm.isActive.value).toLowerCase() === "true";

    const handleSubmitClick = () => {

        const dirtyResource = convertInputFormToObject(itemForm);
        const sanitizedItem = resourceModel(dirtyResource);

        clearInputFormErrorFields(itemForm);

        const isStartDateAfterEndDate = !isStartBeforeEnd(sanitizedItem.whatsNewStartDate, sanitizedItem.whatsNewEndDate)
        const verifyStartAndEndDate = sanitizedItem.whatsNewStartDate && sanitizedItem.whatsNewEndDate;

        if (verifyStartAndEndDate && isStartDateAfterEndDate) {
            itemForm.whatsNewStartDate.setError("Start date must be before end date.");
            itemForm.whatsNewEndDate.setError("End date must be after start date.");
        }

        checkAndSetError([
            itemForm.title,
        ]);

        if (inputFormIsValid(itemForm)) {
            handleSaveResource(sanitizedItem);
        }
    }

    return <>
        <InputForm name={`itemForm`}>
            <TextField {...itemForm.title} medium_columns={gridConstants.column.SIX}/>
            <TextField {...itemForm.author} medium_columns={gridConstants.column.SIX}/>
            <TextArea {...itemForm.description} medium_columns={gridConstants.column.SIX}/>
            <SelectField {...itemForm.gradeLevel} medium_columns={gridConstants.column.SIX} options={GRADE_LEVEL_LIST}/>
            <TextField {...itemForm.accessNumber} medium_columns={gridConstants.column.SIX} disabled />
            <hr/>
            <SelectField {...itemForm.publisherId} medium_columns={gridConstants.column.SIX} label={`Publisher`}
                         options={publishers}/>
            <DateTimePickerField {...itemForm.copyright} medium_columns={gridConstants.column.SIX}/>
            <TextField {...itemForm.isbn10} medium_columns={gridConstants.column.SIX} label="ISBN-10"/>
            <TextField {...itemForm.isbn13} medium_columns={gridConstants.column.SIX} label="ISBN-13"/>
            <TextField {...itemForm.previewIsbn} medium_columns={gridConstants.column.SIX} label="Preview ISBN"/>

            <hr/>
            <DateTimePickerField {...itemForm.whatsNewStartDate} medium_columns={gridConstants.column.SIX} label="What's New Start Date"/>
            <DateTimePickerField {...itemForm.whatsNewEndDate} medium_columns={gridConstants.column.SIX} label="What's New End Date"/>
            
            <hr/>
            <CheckBoxField
                name={itemForm.isActive.name}
                label="Is Active"
                checked={isActive}
                onChange={() => {
                    const newValue = !isActive;
                    itemForm.isActive.setValue(String(newValue));
                }}
                medium_columns={gridConstants.column.SIX}
            />

            <hr/>
            <GridCell className={`text-center`}>
                <Button isPrimary isCollapsed label={'Save'} name={`btnSubmit`}
                        onClick={handleSubmitClick}/>
                <Button isCollapsed label={'Cancel'} name={`btnCancel`} onClick={handleReturn}/>
            </GridCell>
        </InputForm>
    </>;
};

